import { render, staticRenderFns } from "./NonAdmin.vue?vue&type=template&id=346293cb&scoped=true&"
import script from "./NonAdmin.vue?vue&type=script&lang=js&"
export * from "./NonAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346293cb",
  null
  
)

export default component.exports